// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__zY64a","icon--clickable":"Icon_icon--clickable__JU9wH"};